import { render } from "./Mint.vue?vue&type=template&id=47333ac6&ts=true"
import script from "./Mint.vue?vue&type=script&lang=ts"
export * from "./Mint.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__